import { gql } from '@apollo/client';

export const MERGE_COOPERATION_WAREHOUSE_ADDRESSES = gql`
  mutation MergeCooperationWarehouseAddresses($input: MergeAddressInput!) {
    mergeCooperationWarehouseAddresses(input: $input) {
      success
      message
    }
  }
`;

export interface MergeAddressInput {
  targetAddressId: number;
  similarAddressIds: number[];
  forceSubmit: boolean;
}

export interface MergeAddressResponse {
  mergeCooperationWarehouseAddresses: {
    success: boolean;
    message?: string;
  };
}